//production form option start
export const FormOptionsProduction = [
  //key->prodz
  {
    type: "select",
    labelName: "Product",
    placeholder: "Select product",
    isRequired: false,
    valueLabel: "product", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[30%] !inline-block mr-2",
  },
  {
    type: "select",
    labelName: "Vendor",
    placeholder: "Select Vendor",
    isRequired: false,
    valueLabel: "vendor", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[30%] !inline-block mr-2",
  },
  {
    type: "select",
    labelName: "Mold",
    placeholder: "Select mold",
    isRequired: false,
    valueLabel: "mold", //to select correct value for field
    options: [
      // { value: "1", label: "Product1", type: "product },
      // { value: "2", label: "Product2", type: "product" },
    ],
    CustomInputStyle: "w-[30%] !inline-block mr-2",
  },
];

//production form option end

export const FormOptionsProductionTable = [
  {
    type: "text", //for input type
    labelName: "Germany", // for input label
    placeholder: "Enter quantity", //for placeholder
    isRequired: false,
    valueLabel: "germany", //to select correct value for field
  },

  {
    type: "text", //for input type
    labelName: "Burnt And Bubble", // for input label
    placeholder: "Enter quantity", //for placeholder
    isRequired: false,
    valueLabel: "burnt_and_bubble", //to select correct value for field
  },

  {
    type: "text", //for input type
    labelName: "Broken Edge", // for input label
    placeholder: "Enter b", //for placeholder
    isRequired: false,
    valueLabel: "broken_edge", //to select correct value for field
  },
  {
    type: "text", //for input type
    labelName: "Poor Leaf", // for input label
    placeholder: "Enter quantity", //for placeholder
    isRequired: false,
    valueLabel: "broken_edge", //to select correct value for field
  },

  {
    type: "text", //for input type
    labelName: "Germany Total", // for input label
    placeholder: "Enter quantity", //for placeholder
    isRequired: false,
    valueLabel: "germany_total", //to select correct value for field
  },
];
